// src/v2/pages/Transactions/DTRWithOTViewingPage.js
import React from "react";
import DTRWithOTModule from "../../components/modules/DTRWithOT/DTRWithOTModule";

function DTRWithOTViewingPage({ user, isHideSideMenu }) {
  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl bg-white rounded-lg">
          <DTRWithOTModule user={user} />
        </div>
      </div>
    </div>
  );
}

export default DTRWithOTViewingPage;